import { dashboardApi } from '@/api';
import { queryOptions } from '@tanstack/react-query';

interface DataFileSignedUrlQueryArgs {
    projectId: string;
    dashboardId: string | undefined;
    fileType?: 'input' | 'output';
    extension?: 'duckdb' | 'xlsx';
}

export interface DataFileSignedUrlResponse {
    signedUrl: string;
}

const getDataFileSignedUrl = async ({
    projectId,
    fileType = 'output',
    dashboardId,
    extension = 'duckdb',
}: DataFileSignedUrlQueryArgs) => {
    return dashboardApi<DataFileSignedUrlResponse>({
        method: 'GET',
        url: `/front-office/project/${projectId}/data/${fileType}`,
        params: {
            dashboardId,
            extension,
        },
    });
};

const getDuckDBSignedUrl = (
    args: Omit<DataFileSignedUrlQueryArgs, 'extension'>,
) => getDataFileSignedUrl({ ...args, extension: 'duckdb' });

const getExcelSignedUrl = (
    args: Omit<DataFileSignedUrlQueryArgs, 'extension'>,
) => getDataFileSignedUrl({ ...args, extension: 'xlsx' });

export const duckDBSignedUrlQueryOptions = (
    args: Omit<DataFileSignedUrlQueryArgs, 'extension'>,
    options?: { enabled?: boolean },
) =>
    queryOptions({
        queryKey: ['duckdb-signed-url', args],
        queryFn: () => getDuckDBSignedUrl(args),
        staleTime: Infinity,
        ...options,
    });

export const excelSignedUrlQueryOptions = (
    args: Omit<DataFileSignedUrlQueryArgs, 'extension'>,
    options?: { enabled?: boolean },
) =>
    queryOptions({
        queryKey: ['excel-signed-url', args],
        queryFn: () => getExcelSignedUrl(args),
        staleTime: Infinity,
        ...options,
    });

export const dataFileSignedUrlQueryOptions = (
    args: DataFileSignedUrlQueryArgs,
    options?: { enabled?: boolean },
) =>
    queryOptions({
        queryKey: ['data-file-signed-url', args],
        queryFn: () => getDataFileSignedUrl(args),
        staleTime: Infinity,
        ...options,
    });
